import {
    intradays, actualStatement, actualIntraday, statementsCombined, statementsSeparated, transactionsDownloads,
    transactionsIndividualDownloads, VALUE_SERIES, intradaysDownloads
} from '../../services/arsweb/RoutingPaths';

import './report-modal.html';
import { EXPORT_TYPE, TXT_TYPE, PDF_TYPE } from "../export/ExportModalController";
import { FILE_TYPE } from "../../services/export/ExportService";
import { MT94XUserSettingsMapper } from "../../services/export/txt/MT94XUserSettingsMapper";

import moment from 'moment';

const STATEMENT_TRX_REPORT_PREFIX = 'statementTransactionreport_';
const INDIVIDUAL_TRX_REPORT_PREFIX = 'transactionReportIndividual_';
const INTRADAY_TRX_REPORT_PREFIX = 'intradayTransactionreport_';

export const MT940_TYPE = 'MT940';
export const MT942_TYPE = 'MT942';
export const CAMT052_TYPE = 'CAMT052';
export const CAMT053_TYPE = 'CAMT053';
export const REPORT_TYPE = {
    MT940_STATEMENTS: {
        value: 'MT940_STATEMENTS',
        method: 'downloadMT94X',
        type: MT940_TYPE,
        fileMime: TXT_TYPE
    },
    MT940_ACTUAL_STATEMENT: {
        value: 'MT940_ACTUAL_STATEMENT',
        method: 'downloadMT94X',
        type: MT940_TYPE,
        fileMime: TXT_TYPE
    },
    MT940_TRANSACTIONS: {
        value: 'MT940_TRANSACTIONS',
        method: 'downloadMT94X',
        type: MT940_TYPE,
        fileMime: TXT_TYPE
    },
    MT942_INTRADAYS: {
        value: 'MT942_INTRADAYS',
        method: 'downloadMT94X',
        type: MT942_TYPE,
        isIntraday: true,
        noDateRange: true,
        fileMime: TXT_TYPE
    },
    MT942_ACTUAL_INTRADAY: {
        value: 'MT942_ACTUAL_INTRADAY',
        method: 'downloadMT94X',
        type: MT942_TYPE,
        noDateRange: true,
        isIntraday: true,
        fileMime: TXT_TYPE
    },
    CAMT053_STATEMENTS: {
        value: 'CAMT053_STATEMENTS',
        docType: 'CAMT053_STATEMENTS',
        method: 'downloadCAMT05X',
        type: CAMT053_TYPE,
        fileMime: TXT_TYPE
    },
    CAMT053_ACTUAL_STATEMENT: {
        value: 'CAMT053_ACTUAL_STATEMENT',
        docType: 'CAMT053_ACTUAL_STATEMENT',
        method: 'downloadCAMT05X',
        type: CAMT053_TYPE,
        fileMime: TXT_TYPE
    },
    CAMT052_INTRADAYS: {
        value: 'CAMT052_INTRADAYS',
        docType: 'CAMT052_INTRADAYS',
        method: 'downloadCAMT05X',
        type: CAMT052_TYPE,
        isIntraday: true,
        noDateRange: true,
        fileMime: TXT_TYPE
    },
    CAMT052_ACTUAL_INTRADAY: {
        value: 'CAMT052_ACTUAL_INTRADAY',
        docType: 'CAMT052_ACTUAL_INTRADAY',
        method: 'downloadCAMT05X',
        type: CAMT052_TYPE,
        noDateRange: true,
        isIntraday: true,
        fileMime: TXT_TYPE
    },
    PDF_ACTUAL_STATEMENT: {
        value: 'PDF_ACTUAL_STATEMENT',
        method: 'downloadPDF',
        url: actualStatement,
        noDateRange: true,
        noLastAndUnread: false,
        prefix: 'statementreport_',
        fileMime: PDF_TYPE
    },
    PDF_STATEMENTS_COMBINED: {
        value: 'PDF_STATEMENTS_COMBINED',
        method: 'downloadPDF',
        url: statementsCombined,
        noLastAndUnread: false,
        prefix: 'statementreport_',
        fileMime: PDF_TYPE
    },
    PDF_STATEMENTS_SEPARATED: {
        value: 'PDF_STATEMENTS_SEPARATED',
        method: 'downloadPDF',
        url: statementsSeparated,
        noLastAndUnread: false,
        prefix: 'statementreport_',
        fileMime: PDF_TYPE
    },
    PDF_INTRADAYS: {
        value: 'PDF_INTRADAYS',
        method: 'downloadPDF',
        url: intradays,
        prefix: 'intradayreport_',
        noLastAndUnread: false,
        noDateRange: true,
        isIntraday: true,
        fileMime: PDF_TYPE
    },
    PDF_ACTUAL_INTRADAY: {
        value: 'PDF_ACTUAL_INTRADAY',
        method: 'downloadPDF',
        url: actualIntraday,
        noDateRange: true,
        noLastAndUnread: false,
        prefix: 'intradayreport_',
        isIntraday: true,
        fileMime: PDF_TYPE
    },
    PDF_TRANSACTION: {
        value: 'PDF_TRANSACTION',
        method: 'downloadPDF',
        url: "",
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'transactionreport_',
        fileMime: PDF_TYPE
    },
    PDF_TRANSACTION_INDIVIDUAL: {
        value: 'PDF_TRANSACTION_INDIVIDUAL',
        method: 'downloadPDF',
        url: transactionsIndividualDownloads,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: INDIVIDUAL_TRX_REPORT_PREFIX,
        fileMime: PDF_TYPE
    },
    PDF_TRANSACTION_STMT: {
        value: 'PDF_TRANSACTION_STMT',
        method: 'downloadPDF',
        url: "",
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'transactionreport_',
        fileMime: PDF_TYPE
    },
    PDF_TRANSACTION_INTRADAY: {
        value: 'PDF_TRANSACTION_INTRADAY',
        method: 'downloadPDF',
        url: "",
        noDateRange: true,
        isIntraday: true,
        noLastAndUnread: true,
        prefix: 'transactionreport_',
        fileMime: PDF_TYPE
    },
    CSV_TRANSACTION_REPORT: {
        value: 'CSV_TRANSACTION_REPORT',
        method: 'downloadCSV',
        url: transactionsDownloads,
        prefix: STATEMENT_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.CSV.mapFileName,
        userFunction: FILE_TYPE.CSV.userFunction,
        noLastAndUnread: false,
        fileMime: FILE_TYPE.CSV.value
    },
    CSV_TRANSACTION_INDIVIDUAL_REPORT: {
        value: 'CSV_TRANSACTION_INDIVIDUAL_REPORT',
        method: 'downloadCSV',
        url: transactionsIndividualDownloads,
        prefix: INDIVIDUAL_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.CSV.mapFileName,
        userFunction: FILE_TYPE.CSV.userFunction,
        noLastAndUnread: false,
        fileMime: FILE_TYPE.CSV.value
    },
    XLSX_TRANSACTION_REPORT: {
        value: 'XLSX_TRANSACTION_REPORT',
        method: 'downloadXls',
        url: transactionsDownloads,
        prefix: STATEMENT_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        noLastAndUnread: false,
        fileMime: FILE_TYPE.XLSX.value
    },
    XLS_TRANSACTION_REPORT: {
        value: 'XLS_TRANSACTION_REPORT',
        method: 'downloadXls',
        url: transactionsDownloads,
        prefix: STATEMENT_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        noLastAndUnread: false,
        fileMime: FILE_TYPE.XLSX.value
    },
    XLS_TRANSACTION_INDIVIDUAL_REPORT: {
        value: 'XLS_TRANSACTION_INDIVIDUAL_REPORT',
        method: 'downloadXls',
        url: transactionsIndividualDownloads,
        prefix: INDIVIDUAL_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        noLastAndUnread: false,
        fileMime: FILE_TYPE.XLSX.value
    },
    PDF_VALUESERIES: {
        value: 'PDF_VALUESERIES_SEPARATED',
        method: 'downloadPDF',
        url: VALUE_SERIES,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'valueSeriesreport_',
        fileMime: PDF_TYPE
    },
    PDF_VALUESERIES_COMBINED: {
        value: 'PDF_VALUESERIES_COMBINED',
        method: 'downloadPDF',
        url: VALUE_SERIES,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'valueSeriesreport_',
        fileMime: PDF_TYPE
    },
    PDF_VALUESERIES_SUMMARY: {
        value: 'PDF_VALUESERIES_SUMMARY',
        method: 'downloadPDF',
        url: VALUE_SERIES,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'valueSeriesreport_',
        fileMime: PDF_TYPE,
        withSecondaryGrouping: true
    },
    CSV_VALUESERIES_SUMMARY: {
        value: 'CSV_VALUESERIES_SUMMARY',
        method: 'downloadCSV',
        url: VALUE_SERIES,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'ValueDatedBalanceSummaryReport_',
        mapFileName: FILE_TYPE.CSV.mapFileName,
        userFunction: FILE_TYPE.CSV.userFunction,
        fileMime: FILE_TYPE.CSV.value
    },
    XLS_VALUESERIES_SUMMARY: {
        value: 'XLSX_VALUESERIES_SUMMARY',
        method: 'downloadXls',
        url: VALUE_SERIES,
        noDateRange: true,
        noLastAndUnread: true,
        prefix: 'ValueDatedBalanceSummaryReport_',
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        fileMime: FILE_TYPE.XLSX.value
    },
    CSV_TRANSACTION_INTRADAY_REPORT: {
        value: 'CSV_TRANSACTION_INTRADAY_REPORT',
        method: 'downloadCSV',
        url: intradaysDownloads,
        prefix: INTRADAY_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.CSV.mapFileName,
        userFunction: FILE_TYPE.CSV.userFunction,
        noLastAndUnread: false,
        noDateRange: true,
        isIntraday: true,
        fileMime: FILE_TYPE.CSV.value
    },
    XLS_TRANSACTION_INTRADAY_REPORT: {
        value: 'XLSX_TRANSACTION_INTRADAY_REPORT',
        method: 'downloadXls',
        url: intradaysDownloads,
        prefix: INTRADAY_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        noLastAndUnread: false,
        noDateRange: true,
        isIntraday: true,
        fileMime: FILE_TYPE.XLSX.value
    },
    XLSX_TRANSACTION_INTRADAY_REPORT: {
        value: 'XLSX_TRANSACTION_INTRADAY_REPORT',
        method: 'downloadXls',
        url: intradaysDownloads,
        prefix: INTRADAY_TRX_REPORT_PREFIX,
        mapFileName: FILE_TYPE.XLSX.mapFileName,
        userFunction: FILE_TYPE.XLSX.userFunction,
        noLastAndUnread: false,
        noDateRange: true,
        isIntraday: true,
        fileMime: FILE_TYPE.XLSX.value
    }
};

/** @ngInject */
export class ReportModalController {

    constructor($rootScope, $mdDialog, sessionPersistance, reportModalBean) {
        this.$rootScope = $rootScope;
        this.DEFAULT_DAYS = 10;
        this.modalInstance = $mdDialog;
        this.supportedReports = reportModalBean.supportedReports;
        this.withDateRange = reportModalBean.withDateRange;
        this.selectedReport = this.supportedReports[0].value;
        this.reportModalBean = reportModalBean;
        this.sessionPersistance = sessionPersistance;
        this.lastStatement = false;
        this.unRead = false;
        this.withLastAndUnread = reportModalBean.withLastAndUnread;
        this.mT94XUserSettingsMapper = new MT94XUserSettingsMapper(sessionPersistance);
        if (this.withDateRange) {
            const startDate = moment();
            startDate.subtract(this.DEFAULT_DAYS, 'days');
            this.dateRange = { dateFrom: startDate, dateTo: moment() };
        }
    }

    setWithDateRange(selectedReport) {
        this.withDateRange = this.reportModalBean.withDateRange && !REPORT_TYPE[selectedReport].noDateRange;
        this.isIntraday = REPORT_TYPE[selectedReport].isIntraday;
        this.withLastAndUnread = this.reportModalBean.withDateRange && !REPORT_TYPE[selectedReport].noLastAndUnread;
        this.withStatementData = false;
        this.withBalance = false;
    }

    confirm() {
        this.$rootScope.$broadcast('reportType', this.getParams());
        return this.modalInstance.hide();
    }

    closeDialog() {
        this.$rootScope.$broadcast('cancelReportType', this.getParams());
        return this.modalInstance.cancel();
    }

    getParams() {
        const reportModelBeanParams = this.reportModalBean.params || {};
        const mt94xSettings = this.mT94XUserSettingsMapper.getMT94XUserSettings(REPORT_TYPE[this.selectedReport].type);
        const paramsAttributes = {
            reportType: REPORT_TYPE[this.selectedReport],
            withDateRange: this.withDateRange,
            group: this.reportModalBean.group
        };
        const params = Object.assign(reportModelBeanParams, paramsAttributes, mt94xSettings);

        if (this.withDateRange && this.dateRange) {
            params.dateRange = {
                lowerBound: this.dateRange.dateFrom, upperBound: this.dateRange.dateTo, kind: 'dateRange',
                unRead: this.unRead, lastStatement: this.lastStatement
            };
        }

        params.lastStatement = this.lastStatement;
        params.unRead = this.unRead;
        params.withStatementData = this.withStatementData;
        params.withBalance = this.withBalance;

        if (params.reportType.method === EXPORT_TYPE.CSV.method || params.reportType.method === EXPORT_TYPE.XLS.method) {
            params.userFunction = params.reportType.userFunction;
            params.mapFileName = params.reportType.mapFileName;
        }
        return params;
    }
}
